import { LanguageType } from '@/pages/opinion/types/common';
import {
  arrayToSimpleObj,
  dealwithNewOldData,
  getPercentageValue,
  getRationPercentValue,
  handleMentionData,
  initialUpperCase,
  sortTimeListFunc,
  supplementSingleData,
  transAbbreviation,
} from '@/pages/opinion/utils';
import { getContentDetail, getTextByGlobal } from '@/pages/opinion/utils/languageValue';
import { formatDateFunc, getQOQText } from '@/pages/opinion/utils/time';
import moment from 'moment';
import { EDrilldownMode } from '@op/hooks/useDrilldownParams';

export const getAllTopic = (topicList: Array<any>) => {
  const tier1Topic: Array<string> = [];
  const tier2Topic: Array<string> = [];

  if (topicList?.length > 0) {
    topicList.forEach(item => {
      tier1Topic.push(item.id);
      if (item?.children?.length > 0) {
        item.children.forEach((element: { id: string }) => {
          tier2Topic.push(element.id);
        });
      }
    });
  }

  return {
    parent: tier1Topic,
    children: tier2Topic,
    flag: true,
  };
};

// 点击话题跳转Feeds下有数据的tab
export const clickTopicToFeeds = async (
  topics: Array<string>,
  commonParams: {
    start_time: moment.MomentInput;
    end_time: moment.MomentInput;
    edition_unified_id: any;
  },
  goPage: (params: any) => Promise<void>,
) => {
  await goPage({
    path: `/opinion/Feeds/Feeds?tab=socialMedia`,
    filter: {
      statsDetailType: 'feeds-topicTracking',
      ...commonParams,
      topic: topics,
    },
    mode: EDrilldownMode.Local,
  });
};

export default function dealwithMetics(
  list: any[],
  oldList: any[],
  totalMap?: { [key: string]: any },
  old_total_metrics?: { [key: string]: any },
): Array<any> {
  if (!list || list?.length === 0) {
    return [];
  }
  let keys = [
    'mentions',
    'negative_mentions',
    'sentiment',
    'mentions_ratio',
    'negative_mentions_value',
  ];

  function listDealwith(
    item: { metrics: { [x: string]: number; mentions: any } },
    type: string,
  ) {
    let orgData: any = {
      ...item,
      ...item.metrics,
    };

    const metricsObj = item.metrics || {};
    // 补充两份原始数据，这两个数据用于二级话题占比计算使用
    if (Object.prototype.hasOwnProperty.call(metricsObj, 'negative_mentions')) {
      let value = item.metrics['negative_mentions'] || 0;
      let totalValue = item.metrics.mentions || 0;
      // let totalValue = realTotalMapInfo?.['negative_mentions'] || 0;
      orgData['negative_mentions'] = getPercentageValue(value, totalValue, 4);
      orgData['negative_mentions_value'] = value;
    }

    if (Object.prototype.hasOwnProperty.call(metricsObj, 'mentions')) {
      let value = item.metrics['mentions'] || 0;
      orgData['mentions_value'] = value;
    }

    if (totalMap) {
      orgData['mentions_ratio'] = getPercentageValue(
        item?.metrics?.mentions || 0,
        totalMap.mentions,
        4,
      );
    }
    return orgData;
  }

  return dealwithNewOldData(
    list?.map((item: any) => listDealwith(item, 'new')),
    oldList?.map((item: any) => listDealwith(item, 'old')),
    'topic',
    keys,
    (_item: any, oldItem: any) => {
      const obj: any = keys.reduce(
        (pre, cur) => ({ ...pre, [cur + '_old']: oldItem?.[cur] || 0 }),
        {},
      );
      if (old_total_metrics) {
        // 旧占比值矫正一下
        let mentions_ratio_old = getPercentageValue(
          oldItem?.mentions || 0,
          old_total_metrics.mentions,
          8,
        );
        obj['mentions_ratio_old'] = mentions_ratio_old;
        let mentions_ratio_new = getPercentageValue(
          _item?.mentions || 0,
          totalMap?.mentions,
          8,
        );
        obj['mentions_ratio_than'] = getRationPercentValue(
          mentions_ratio_new,
          mentions_ratio_old,
          8,
        );
      }
      return { ...obj, totalMap };
    },
  );
}

export function dealwithTimeLineData(
  resData: {
    timeline_of_start_time: any;
    timeline_of_end_time: any;
    timeline: any;
    sorts: any;
    sum: any;
  },
  topicSum: any,
  dateType: string,
  indicators: string,
  calculateTableData: boolean | undefined,
  calculateMaximumDifference: boolean | undefined,
  startTime: any,
  endTime: moment.MomentInput,
  topicLevel?: string,
) {
  let { timeline_of_start_time, timeline_of_end_time, timeline, sorts, sum } =
    resData;
  // topicLevel === 'L2' && sorts?.push('Others');
  let data = supplementSingleData(
    timeline_of_start_time,
    timeline_of_end_time,
    timeline?.map((item: { count: any; value: any; key: any }) => ({
      ...item,
      count: item.count || item.value,
      name: item.key,
    })),
    dateType,
    sorts,
  );
  const needTime = ['daily', 'weekly'].includes(dateType)
    ? 'days'
    : dateType === 'hourly'
    ? 'hourly'
    : 'year';

  const formatDate = formatDateFunc(dateType);
  // {
  //   dealwithCustomTotal: (v: { count: any; name: string }) =>
  //     v.name === 'Others' ? 0 : v.count,
  //   dealwithCustomTotalKey: (v: { time: string }) => formatDate(v.time),
  // }
  let { newArr, timeArr } = handleMentionData(data, needTime);
  newArr?.sort(
    (a: { name: any }, b: { name: any }) =>
      sorts?.indexOf(a.name) - sorts?.indexOf(b.name),
  );

  sum = topicSum || sum;

  let sumMap = arrayToSimpleObj(sum, 'value', (item: { time: any }) =>
    formatDate(item.time),
  );
  if (['mentions_ratio', 'negative_mentions'].includes(indicators)) {
    newArr = newArr.map((item: { data: any[] }) => {
      return {
        ...item,
        originData: item.data,
        data: item.data.map((value: any, i: string | number) =>
          getPercentageValue(value, sumMap[timeArr[i]], 10),
        ),
      };
    });
  }
  let result: any = {
    newArr: newArr || [],
    sumMap,
    timeArr,
    tableInfo: {
      header: [],
      data: [],
    },
    maximumDifference: [],
  };

  if (calculateTableData) {
    let tableData: Array<any> = timeArr.map(
      (time: string | number, index: string | number) => {
        let itemObj: any = { time };
        // let total = 0;
        newArr.forEach(({ data, name }) => {
          itemObj[name] = data[index];
          // total += data[index] || 0;
        });
        itemObj['total'] = sumMap[time];
        return itemObj;
      },
    );
    tableData.sort(sortTimeListFunc('time', 'desc'));
    result['tableInfo'] = { header: sorts, data: tableData };
  }

  if (calculateMaximumDifference) {
    const sameTimeObj = getQOQText(dateType, startTime, endTime);
    let maxData = newArr
      .filter((item: { name: string }) => item.name !== 'Others')
      .map((item: { name?: any; data: any; originData: any }) => {
        let { data, originData } = item;
        let maxIndex = data.length - 1;
        // let sameTimeIndex = maxIndex - 1;
        const value = data[maxIndex] || 0,
          oldValue = data[0] || 0;
        // sameOldValue = data[sameTimeIndex] || 0;

        let { isSingleDay, isSingleWeek, isSingleMonth } = sameTimeObj || {};
        const sameTime = isSingleDay || isSingleWeek || isSingleMonth;

        let newTime = [timeArr[maxIndex]];
        let oldTime = [timeArr[0]];

        let total =
          data?.reduce((pre: number, cur: number) => pre + cur, 0) || 0;

        if (['mentions_ratio', 'negative_mentions'].includes(indicators)) {
          total =
            originData?.reduce((pre: number, cur: any) => pre + cur, 0) || 0;

          let sumTotal =
            sum?.reduce((pre: number, cur: any) => pre + cur.value, 0) || 0;
          total = getPercentageValue(total, sumTotal, 10);
        }

        // let oldTime = [sameTime ? timeArr[sameTimeIndex] : timeArr[0]];

        // if (dateType === 'weekly') {
        //   let nt = moment(endTime).subtract(6, 'day').format('YYYY-MM-DD');
        //   let ot = moment(oldTime[0]).add(6, 'day').format('YYYY-MM-DD');
        //   newTime = [nt, endTime];
        //   oldTime = [oldTime[0], ot];
        // }
        // const newOldValue = sameTime ? sameOldValue : oldValue;

        return {
          totalValue: sameTime ? value : total,
          value: value,
          oldValue: oldValue,
          percentage: getRationPercentValue(value, oldValue),
          newTime: newTime,
          oldTime: oldTime,
          maximum: value - oldValue,
          name: item.name,
          y: item.data,
          x: timeArr,
          valueIsZero: oldValue === 0 || value === 0,
        };
      });
    let filterBeforeData = maxData;
    if (indicators === 'sentiment') {
      filterBeforeData = filterBeforeData.filter(
        (a: { valueIsZero: any }) => !a.valueIsZero,
      );
    }
    filterBeforeData.sort((a, b) => b.percentage - a.percentage);
    result['maximumDifference'] = filterBeforeData;
  }

  return result;
}

const eventTitleMap = {
  en: 'event_title_en',
  zh: 'event_title_cn',
  origin: 'event_title',
};

const eventContentMap = {
  en: 'event_gpt_content_en',
  zh: 'event_gpt_content_cn',
  origin: 'event_gpt_content',
};

/**
 * TODO: 其他系统使用
 * 获取事件数据标题中英文
 * @param item
 * @param language
 * @returns
 */
export function getEventTitleText(item: any, language: LanguageType) {
  return getContentDetail(eventTitleMap, language, item);
}


export function getEventTitleTextGlobal(item: any, isEn: boolean) {
  return getTextByGlobal(eventTitleMap, isEn, item);
}

export function getEventContentText(item: any, language: LanguageType) {
  return getContentDetail(eventContentMap, language, item);
}
 
export function dealwithKeywordStr(
  item: any,
  dealwithContent: (region: string, text: any, flag: boolean) => any,
) {
  let { keyword, transls } = item || {};
  let keywordArray = keyword?.split('|') || [];
  transls = JSON.parse(transls || '{}');
  let result: Array<any> = [];
  for (const key in transls) {
    const element = transls[key]?.[0]?.split('|') || [];
    const list = element.slice(0, keywordArray.length);
    list.forEach((text: any, index: number) => {
      if (!result[index]) {
        result[index] = {
          origin: initialUpperCase(keywordArray?.[index]),
          content: [],
        };
      }
      const region = transAbbreviation(key, 'lang_en');
      result[index]['content'].push(
        dealwithContent(
          region,
          initialUpperCase(text),
          index === list.length - 1,
        ),
      );
    });
  }

  return result;
}

export function dealwithKeywordListStr(
  list: any,
  dealwithContent: (region: string, text: any, flag: boolean) => any,
) {
  const result = (list || []).map((item: any) => {
    return dealwithKeywordStr(item, dealwithContent);
  });

  const allList = result
    .flat(Infinity)
    .map((item: Array<{ origin: any }>) => item.origin);

  return allList;
}

function calculateValue({
  oldValue,
  newValue,
  key,
  oldTotal,
  newTotal,
}: {
  oldValue: number;
  newValue: number;
  key: string;
  oldTotal: number;
  newTotal: number;
}) {
  // 环比
  const qoq = getRationPercentValue(newValue, oldValue);
  const oldKey = key + '_old';
  const qoqKey = key + '_qoq';
  const result = {
    [oldKey]: oldValue,
    [qoqKey]: qoq,
    [key]: newValue,
  };

  // 新声量占比
  const ratio = getPercentageValue(newValue, newTotal, 6);
  // 老声量占比
  const oldRatio = getPercentageValue(oldValue, oldTotal, 6);
  // 声量占比环比
  const ratioQoq = getRationPercentValue(ratio, oldRatio);

  return {
    ...result,
    [key + '_ratio']: ratio,
    [key + '_ratio_old']: oldRatio,
    [key + '_ratio_qoq']: ratioQoq,
  };
}

function calculateTableData({
  metrics,
  oldMetrics,
  totalMentions,
  oldTotalMentions,
}: {
  metrics: { [key: string]: number };
  oldMetrics: { [key: string]: number };
  totalMentions: number;
  oldTotalMentions: number;
}) {
  return Object.keys(metrics || {}).reduce((pre: any, key: string) => {
    const oldValue = oldMetrics?.[key] || 0;
    const newValue = metrics[key] || 0;

    const data = calculateValue({
      oldValue,
      newValue,
      newTotal: totalMentions,
      oldTotal: oldTotalMentions,
      key,
    });

    return { ...pre, ...data };
  }, {});
}

function calculateWeekTableData({
  metrics = {},
  oldMetrics = {},
  needCalculate,
}: {
  metrics: { [key: string]: number };
  oldMetrics: { [key: string]: number };
  needCalculate: boolean;
}) {
  if (!needCalculate) return {};
  return Object.keys(metrics || {}).reduce((pre: any, key: string) => {
    const oldValue = oldMetrics?.[key] || 0;
    const newValue = metrics[key] || 0;

    const qoq = getRationPercentValue(newValue, oldValue);

    return { ...pre, [`${key}_week_qoq`]: qoq, [`${key}_week`]: oldValue };
  }, {});
}

export function dealwithTopicList(data: any, filter: any) {
  const {
    old_start_date,
    old_end_date,
    new_start_date,
    new_end_date,
    list,
    old_list,
    old_total_metrics,
    total,
    total_metrics,
    ext_links,
  } = data;

  const oldListMap = arrayToSimpleObj(old_list, 'metrics', 'topic');

  const weekData = ext_links.find(
    (item: { type: string }) => item.type === 'week_link',
  );

  const {
    old_list: week_old_list,
    link_of_start_time: week_link_of_start_time,
    link_of_end_time: week_link_of_end_time,
  } = weekData || {};
  const weekOldListMap = arrayToSimpleObj(week_old_list, 'metrics', 'topic');

  const totalMentions = total_metrics.mentions;
  const oldTotalMentions = old_total_metrics.mentions;
  const result = (list || []).map(({ topic, child_topics, metrics }: any) => {
    // 计算环比
    const oldMetrics = oldListMap[topic];
    const values = calculateTableData({
      metrics,
      oldMetrics,
      totalMentions,
      oldTotalMentions,
    });

    // 计算周环比
    const weekOldMetrics = weekOldListMap[topic];
    const weekValue = calculateWeekTableData({
      metrics,
      oldMetrics: weekOldMetrics,
      needCalculate: !!weekData,
    });

    return {
      topic,
      child_topics,
      newTimes: [new_start_date, new_end_date],
      oldTimes: [old_start_date, old_end_date],
      oldWeekTime: [week_link_of_start_time, week_link_of_end_time],
      ...values,
      ...weekValue,
    };
  });

  return {
    tableData: result,
    total: total || 0,
  };
}
